// Polling Agent (Interview Agent) Reducer
import {
  GET_POLLING_AGENTS,
  GET_POLLING_AGENTS_SUCCESS,
  GET_POLLING_AGENTS_FAIL,
  GET_POLLING_AGENTS_RESET,
  GET_POLLING_AGENT_BY_ID,
  GET_POLLING_AGENT_BY_ID_SUCCESS,
  GET_POLLING_AGENT_BY_ID_FAIL,
  GET_POLLING_AGENT_BY_ID_RESET,
  CREATE_POLLING_AGENT,
  CREATE_POLLING_AGENT_SUCCESS,
  CREATE_POLLING_AGENT_FAIL,
  CREATE_POLLING_AGENT_RESET,
  UPDATE_POLLING_AGENT,
  UPDATE_POLLING_AGENT_SUCCESS,
  UPDATE_POLLING_AGENT_FAIL,
  UPDATE_POLLING_AGENT_RESET,
  DELETE_POLLING_AGENT,
  DELETE_POLLING_AGENT_SUCCESS,
  DELETE_POLLING_AGENT_FAIL,
  DELETE_POLLING_AGENT_RESET,
  GET_VOICES,
  GET_VOICES_SUCCESS,
  GET_VOICES_FAIL,
  GET_VOICES_RESET,
} from '../actions/pollingAgentAction';

const initialState = {
  // Get Polling Agents
  getPollingAgentsState: {
    apiState: 'idle', // idle, loading, success, error
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Get Polling Agent By ID
  getPollingAgentByIdState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Create Polling Agent
  createPollingAgentState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Update Polling Agent
  updatePollingAgentState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Delete Polling Agent
  deletePollingAgentState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Get Voices
  getVoicesState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
};

const pollingAgentReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Polling Agents
    case GET_POLLING_AGENTS:
      return {
        ...state,
        getPollingAgentsState: {
          ...state.getPollingAgentsState,
          apiState: 'loading',
        },
      };
    case GET_POLLING_AGENTS_SUCCESS:
      return {
        ...state,
        getPollingAgentsState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Polling agents retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_POLLING_AGENTS_FAIL:
      return {
        ...state,
        getPollingAgentsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch polling agents',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_POLLING_AGENTS_RESET:
      return {
        ...state,
        getPollingAgentsState: initialState.getPollingAgentsState,
      };

    // Get Polling Agent By ID
    case GET_POLLING_AGENT_BY_ID:
      return {
        ...state,
        getPollingAgentByIdState: {
          ...state.getPollingAgentByIdState,
          apiState: 'loading',
        },
      };
    case GET_POLLING_AGENT_BY_ID_SUCCESS:
      return {
        ...state,
        getPollingAgentByIdState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Polling agent retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_POLLING_AGENT_BY_ID_FAIL:
      return {
        ...state,
        getPollingAgentByIdState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch polling agent',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_POLLING_AGENT_BY_ID_RESET:
      return {
        ...state,
        getPollingAgentByIdState: initialState.getPollingAgentByIdState,
      };

    // Create Polling Agent
    case CREATE_POLLING_AGENT:
      return {
        ...state,
        createPollingAgentState: {
          ...state.createPollingAgentState,
          apiState: 'loading',
        },
      };
    case CREATE_POLLING_AGENT_SUCCESS:
      return {
        ...state,
        createPollingAgentState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Polling agent created successfully',
          errors: action.response.errors || null,
        },
      };
    case CREATE_POLLING_AGENT_FAIL:
      return {
        ...state,
        createPollingAgentState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to create polling agent',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CREATE_POLLING_AGENT_RESET:
      return {
        ...state,
        createPollingAgentState: initialState.createPollingAgentState,
      };

    // Update Polling Agent
    case UPDATE_POLLING_AGENT:
      return {
        ...state,
        updatePollingAgentState: {
          ...state.updatePollingAgentState,
          apiState: 'loading',
        },
      };
    case UPDATE_POLLING_AGENT_SUCCESS:
      return {
        ...state,
        updatePollingAgentState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Polling agent updated successfully',
          errors: action.response.errors || null,
        },
      };
    case UPDATE_POLLING_AGENT_FAIL:
      return {
        ...state,
        updatePollingAgentState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update polling agent',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_POLLING_AGENT_RESET:
      return {
        ...state,
        updatePollingAgentState: initialState.updatePollingAgentState,
      };

    // Delete Polling Agent
    case DELETE_POLLING_AGENT:
      return {
        ...state,
        deletePollingAgentState: {
          ...state.deletePollingAgentState,
          apiState: 'loading',
        },
      };
    case DELETE_POLLING_AGENT_SUCCESS:
      return {
        ...state,
        deletePollingAgentState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Polling agent deleted successfully',
          errors: action.response.errors || null,
        },
      };
    case DELETE_POLLING_AGENT_FAIL:
      return {
        ...state,
        deletePollingAgentState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to delete polling agent',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_POLLING_AGENT_RESET:
      return {
        ...state,
        deletePollingAgentState: initialState.deletePollingAgentState,
      };

    // Get Voices
    case GET_VOICES:
      return {
        ...state,
        getVoicesState: {
          ...state.getVoicesState,
          apiState: 'loading',
        },
      };
    case GET_VOICES_SUCCESS:
      return {
        ...state,
        getVoicesState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Voices retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_VOICES_FAIL:
      return {
        ...state,
        getVoicesState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch voices',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_VOICES_RESET:
      return {
        ...state,
        getVoicesState: initialState.getVoicesState,
      };

    default:
      return state;
  }
};

export default pollingAgentReducer;

